import { ExternalLink } from "lucide-react";
import { SITE } from "../data/site";
import useReveal from "../hooks/useReveal";

export default function Reel() {
  const ref = useReveal();
  return (
    <section
      id="reel"
      data-testid="reel-section"
      className="relative py-28 sm:py-36 lg:py-44 bg-[#0A0A0C] grain"
    >
      <div ref={ref} className="reveal max-w-7xl mx-auto px-6 sm:px-8 md:px-12">
        <div className="flex items-end justify-between flex-wrap gap-6 mb-12">
          <div>
            <div className="overline text-[#991B1B] mb-6">— Reel</div>
            <h2
              data-testid="reel-title"
              className="font-serif-display text-5xl sm:text-6xl lg:text-7xl text-white tracking-tight leading-[0.95]"
            >
              {SITE.reel.title.split(" ")[0]}{" "}
              <span className="italic text-[#A0A0A8]">{SITE.reel.title.split(" ").slice(1).join(" ")}</span>
            </h2>
            <p className="mt-6 text-[#A0A0A8] max-w-xl text-base sm:text-lg leading-relaxed">
              {SITE.reel.subtitle}
            </p>
          </div>
          <a
            data-testid="reel-youtube-link"
            href={SITE.reel.youtubeUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="cine-link overline inline-flex items-center gap-2"
          >
            Open in YouTube <ExternalLink size={12} />
          </a>
        </div>

        <div className="relative w-full" style={{ aspectRatio: "16 / 9" }}>
          <div className="absolute inset-0 border border-white/5">
            <iframe
              data-testid="reel-iframe"
              src={`https://www.youtube.com/embed/${SITE.reel.youtubeId}?rel=0&modestbranding=1`}
              title="Isaiah Artavia — Performance Reel"
              loading="lazy"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullScreen
              className="w-full h-full"
            />
          </div>
          <div className="absolute -top-3 -left-3 h-12 w-12 border-l border-t border-[#991B1B]/60 pointer-events-none" />
          <div className="absolute -bottom-3 -right-3 h-12 w-12 border-r border-b border-[#D4AF37]/40 pointer-events-none" />
        </div>
      </div>
    </section>
  );
}
